import React from "react";
import Skeleton from "../skeleton";

const Mobile = () => (
	<div className="container">
		<div className="child-container">

			<div>
				<div className="card">
					<div className="list-reviews">
						<div className="product">
							<Skeleton
								width="80px"
								height="80px"
							/>
							<div className="detail-product">
								<Skeleton
									width="88px"
									height="15px"
									borderRadius="8px"
								/>
								<Skeleton
									width="129px"
									height="15px"
									borderRadius="8px"
								/>
								<Skeleton
									width="152px"
									height="15px"
									borderRadius="8px"
								/>
								<Skeleton
									width="208px"
									height="15px"
									borderRadius="8px"
								/>

							</div>
						</div>
						<hr />
						<div className="section-reviews">
							<div className="profile">
								<Skeleton
									width="48px"
									height="48px"
									borderRadius="50%"
								/>
								<div className="" style={{ width: "220px" }}>
									<Skeleton
										width="85px"
										height="15px"
										borderRadius="8px"
									/>
									<Skeleton
										width="116px"
										height="15px"
										borderRadius="8px"
									/>
								</div>
								<Skeleton
									width="46px"
									height="15px"
									borderRadius="8px"
								/>
							</div>
							<div className="reviews">
								<Skeleton
									width="158px"
									height="15px"
									borderRadius="8px"
								/>
								{Array.from({ length: 3 }, (value, id) => (
									<Skeleton
										key={id}
										width="100%"
										height="15px"
										borderRadius="8px"
									/>
								))}
								<Skeleton
									width="80%"
									height="15px"
									borderRadius="8px"
								/>
								{Array.from({ length: 2 }, (velue, id) => (
									<div className="section-place" key={id}>
										<Skeleton
											width="16px"
											height="16px"
											borderRadius="50%"
										/>
										<Skeleton
											width="88px"
											height="15px"
											borderRadius="8px"
										/>
										<span style={{ color: "#dfe3e8" }}>: </span>
										<Skeleton
											width="88px"
											height="15px"
											borderRadius="8px"
										/>
									</div>
								))}
							</div>
							<hr />
							<div className="comment-section">
								<Skeleton
									width="88px"
									height="15px"
									borderRadius="8px"
								/>
								<Skeleton
									width="16px"
									height="16px"
									borderRadius="50%"
								/>
							</div>
						</div>
					</div>

				</div>
			</div>

		</div>
		<style jsx>
			{`
        @media (min-width: 480px) {
          .container{
            display: flex;
            max-width: 480px;
						margin: 0 auto;
            justify-content: center;
          }
          .chils-container{
            max-width: 480px;
          }
        }

        .container{
          max-width: 480px;
					margin: 0 auto;
					padding: 16px;
        }
        .title-reviews{
          display: flex;
          flex-direction: column;
          gap: 10px;
        }
        .tab-reviews {
          display: flex;
          gap: 8px;
          overflow-x: scroll;
        }
        .product{
          display: flex;
          align-items: center;
          gap: 10px;
          margin-top: 20px;
        }
        .section-bs{
          display: flex;
          gap: 10px;
        }
        .profile{
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .section-place{
          display: flex;
          gap: 5px;
        }
        .comment-section{
          display: flex;
          justify-content: space-between;
        }
        .section-blank{
          margin-left: -16px;
        }
        .pagination{
          display: flex;
          gap: 5px;
          align-items: center;
        }
        hr{
          border: 1px solid #dfe3e8;
        }
    `}
		</style>
	</div>
);

export default Mobile;
